import { render } from "./navigationlink.vue?vue&type=template&id=6c71be39&scoped=true"
import script from "./navigationlink.vue?vue&type=script&lang=js"
export * from "./navigationlink.vue?vue&type=script&lang=js"

import "./navigationlink.vue?vue&type=style&index=0&id=6c71be39&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c71be39"]])

export default __exports__